import SavedSearchFilter from './SavedSearchFilter.js';
import FilterField from './FilterField.js';
import NestedFilter from './NestedFilter.js';
import ValueRange from './ValueRange.js';

export default [
	{ name: 'RecordFilter', dataModel: SavedSearchFilter }, /* OLD NAME */
	{ name: 'SavedSearchFilter', dataModel: SavedSearchFilter },
	{ name: 'FilterField', dataModel: FilterField },
	{ name: 'NestedFilter', dataModel: NestedFilter },
	{ name: 'ValueRange', dataModel: ValueRange }
];
